const rebate = {
    state: {
        ladderData: [],
        groupingData: [],
        autogroupData: {},
        advancedData: {},
        groupingDataStatus: false
    },

    mutations: {
        SET_REBATE_LADDERDATA (state, data) {
            state.ladderData = data
        },
        SET_REBATE_GROUPINGDATA (state, data) {
            state.groupingData = data
        },
        SET_REBATE_AUTOGROUPDATA (state, data) {
            state.autogroupData = data
        },
        SET_REBATE_ADVANCEDDATA (state, data) {
            state.advancedData = data
        },
        SET_REBATE_GROUPINGDATA_STATUS (state, data) {
            if (data >= 0) {
                state.groupingDataStatus = true
            } else {
                state.groupingDataStatus = false
            }
        }
    },

    actions: {

    }
}
export default rebate
